import Color from '@/Enums/Color.enum';
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';

interface IProps {
  onClick: () => void;
}

const RemoveButton = ({ onClick }: IProps) => (
  <IconButton aria-label='Remove' onClick={onClick} sx={{ minWidth: 0, padding: 0 }}>
    <Close sx={{ color: Color.Grey, width: '16px', height: '16px', flexGrow: 0 }} />
  </IconButton>
);

export default RemoveButton;
